import React, { useEffect, useState } from 'react'
import "./Overview.css"
import OverviewCard from './OverviewCard'
import clicksImg from "../../../assets/images/clicks.svg";
import ReachImg from "../../../assets/images/reach.svg";
import CtrImg from "../../../assets/icons/likes.png";
import WhatsAppImg from "../../../assets/icons/business-icon.svg";
import profitIcon from "../../../assets/icons/ProfitIcon.svg";
import lossIcon from "../../../assets/icons/lossIcon.svg";
import adSpendIcon from "../../../assets/images/ad-spend.svg"

const Overview = ({campaigns}) => {
  const [clicks, setClicks] = useState("0")
  const [reach, setReach] = useState("0")
  const [whatsAppEnquiry, setWhatsAppEnquery] = useState("0") ;
  const [likes, setLikes] = useState("0")
  const [adSpend, setAdSpend] = useState("0") 

  useEffect(() =>{
    let tmpClicks = 0 ;
    let tmpReach = 0 ;
    let tmpWhatAppEnuiry = 0 ;
    let tmpLikes = 0 ;
    let tmpSpend = 0 ;

    if (campaigns?.length) {
      campaigns?.map(item => {
        tmpReach = tmpReach + item?.results ;
        tmpWhatAppEnuiry = tmpWhatAppEnuiry + item?.chat ;
        tmpLikes = tmpLikes + item?.likes
        tmpSpend = tmpSpend + item?.spend
      })

      setClicks(tmpClicks)
      setReach(tmpReach)
      setWhatsAppEnquery(tmpWhatAppEnuiry)
      setLikes(tmpLikes)
      setAdSpend(parseFloat(tmpSpend).toFixed(1))
    }
  }, [campaigns])

  return (
    <div id='overview'>
        <h5 className="overview-heading">Overview</h5>
        <hr className='overview-hr-line' />
        <div className="overview-cards">
            {/* <OverviewCard overviewCardBorder="clicks" src={clicksImg} alt="clicks-img" title="Clicks" subTitle={clicks} class="loss" profitAndLoss="2.5" profitAndLossIconSrc={lossIcon} profitAndLossalt="loss-icon" /> */}
            <OverviewCard overviewCardBorder="reach" src={ReachImg} alt="reach-img" title="Reach" subTitle={reach} class="profit" profitAndLoss="4.5" profitAndLossIconSrc={profitIcon} profitAndLossalt="profit-icon" />
            <OverviewCard overviewCardBorder="likes" src={CtrImg} alt="ctr-img" title="Likes" subTitle={likes} class="profit" profitAndLoss="65" profitAndLossIconSrc={profitIcon} profitAndLossalt="profit-icon" />
            <OverviewCard overviewCardBorder="whatsapp-enquiry" src={WhatsAppImg} alt="whatsapp-img" title="Whatsapp enquiry" subTitle={whatsAppEnquiry} class="loss" profitAndLoss="2.5" profitAndLossIconSrc={lossIcon} profitAndLossalt="loss-icon" />
            <OverviewCard overviewCardBorder="adspend" src={adSpendIcon} alt="ad-spend" title="Ad spend" prefix="₹" subTitle={adSpend} class="loss" profitAndLoss="2.5" profitAndLossIconSrc={lossIcon} profitAndLossalt="loss-icon" />
        </div>
    </div>
  )
}

export default Overview